import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for MCP UI Renderer node
 * 
 * This is a pure sub-node tool, so defaults are minimal.
 * All actual parameters come from the AI agent at invocation time.
 */
const defaults: NodeParameters = {};

export default defaults;
